import { Component, inject } from '@angular/core';
import { UserService } from 'src/app/services/uppy/user.service';

@Component({
    selector: 'app-base',
    template: ``,
    styles: [],
    standalone: false
})
export class BaseComponent {
  PERMISSIONS_KEY = 'permissions'
  public showWithdrawButton = false;
  public showIssueRecordOfCompletionButton = false;
  public showManageClassroomButton = false;
  public showManageEnrolmentButton = false;
  public showEnrolLearnerButton = false;
  public showCreateApplicationButton = false;
  constructor() { this.setPermissions(); }


  setPermissions() {
    const userService = inject(UserService);
    userService.getAuthorizedFeaturesForCurrentUser().subscribe((features) => {
      sessionStorage.removeItem(this.PERMISSIONS_KEY)
      sessionStorage.setItem(this.PERMISSIONS_KEY, JSON.stringify(features))
      const permissionsAsString = sessionStorage.getItem(this.PERMISSIONS_KEY);
      const permissions = JSON.parse(permissionsAsString ?? '[]');
      if (!permissions.length) return;
      if (permissions.includes('all')) {
        this.showWithdrawButton = true;
        this.showIssueRecordOfCompletionButton = true;
        this.showManageClassroomButton = true;
        this.showManageEnrolmentButton = true;
        this.showEnrolLearnerButton = true;
        this.showCreateApplicationButton = true;
      } else {
        this.showWithdrawButton = permissions.includes('withdram-program');
        this.showIssueRecordOfCompletionButton = permissions.includes('issue-certificate');
        this.showManageClassroomButton = permissions.includes('manage-classroom');
        this.showManageEnrolmentButton = permissions.includes('manage-enrolment');
        this.showEnrolLearnerButton = permissions.includes('enrol-learner');
        this.showCreateApplicationButton = permissions.includes('create-application');
      }
    });
  }
}
